import React from "react";
import Button from "components/UI/Button";
import ModalOverlay from "components/UI/ModalOverlay";

const PaymentModal = props => (
  <ModalOverlay
    header={
      <p style={{ letterSpacing: "2px" }}>Opps! There seems to be an Error</p>
    }
    close={props.close}
    bodyStyle={{
      width: "1000px"
    }}
  >
    <div
      style={{
        width: "90%",
        padding: "2rem",
        fontSize: "20px"
      }}
    >
      {props.text}
    </div>
    <Button
      type="primary"
      onClick={props.close}
      style={{
        width: "230px",
        margin: "20px",
        fontSize: "20px"
      }}
    >
      CLOSE
    </Button>
  </ModalOverlay>
);

export default PaymentModal;
